var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgId = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.54 6h12.92c.806 0 1.58.316 2.15.879S21.5 8.204 21.5 9v6a2.98 2.98 0 0 1-.89 2.121 3.06 3.06 0 0 1-2.15.879H5.54a3.06 3.06 0 0 1-2.15-.879A2.98 2.98 0 0 1 2.5 15V9c0-.796.32-1.559.89-2.121A3.06 3.06 0 0 1 5.54 6m2.65 7.427v.823h3.365v-.823h-1.218v-3.079h1.218v-.823H8.189v.823H9.4v3.079zm4.076-3.902v4.732q.09.014.253.023.164.011.342.02a15 15 0 0 0 .63.024q.69 0 1.132-.212a1.8 1.8 0 0 0 .69-.561q.25-.348.346-.793.096-.451.095-.911 0-.513-.095-.948a1.9 1.9 0 0 0-.34-.756 1.6 1.6 0 0 0-.659-.503q-.418-.183-1.053-.183-.39.005-.777.024-.283.014-.564.044m1.375.756q.39 0 .615.149.225.148.34.377.112.23.142.507c.043.374.042.753-.003 1.127a1.6 1.6 0 0 1-.15.533.9.9 0 0 1-.352.382q-.237.145-.633.145l-.315-.017a1 1 0 0 1-.082-.01v-3.166l.185-.017a3 3 0 0 1 .253-.01",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/id.1d4bb2e7.svg";